<template>
  <div class="out_wrap seal">
    <div class="tit">
      <div class="txt">印章</div>
      <el-popover
        placement="bottom"
        width="180"
        trigger="click"
      >
        <img src="@/assets/demo.png" style="width:100%;">
        <div slot="reference" class="active_color fs14 pointer">示例图</div>
      </el-popover>
    </div>
    <div class="seal-img">
      <img v-if="companySeal" class="img" :src="companySeal" alt="印章">
<!--      <el-button v-else-if="powerReg('133e09d26fe320ab9d3534d5afe4e7e2')" type="primary" size="small" @click="apply">印章申请</el-button>-->
      <div class="tips mt10">说明：印章及线上签署服务与第三方e签宝合作，可靠合规，具有法律效力。</div>
    </div>
    <div class="tit mt40">
      <div class="txt">印章授权</div>
    </div>
    <div class="auth-seal mt20 flex">
      <div v-for="item in userArr" :key="item.account_id" :class="['auth-item list', curUser === item.account_id ? 'active' : '']" @click="clickUser(item)">
        <i v-if="curUser === item.account_id" class="el-icon-circle-close pointer" @click="close(item)" />
        <div class="ellipsis center" style="width:100%;">{{ item.nickname }}</div>
      </div>
      <div v-if="powerReg('b6c978b01e86748c7ee5ee09d6f606a9')" class="auth-item add-seal pointer" @click="addUser">
        <i class="el-icon-plus" />
        <div>点击添加</div>
      </div>
    </div>
    <el-dialog title="添加" :visible.sync="addVisible" width="400px" center :before-close="beforeClose">
      <el-form ref="addForm" :model="addForm" label-position="right" label-width="100px" size="small" :rules="uploadFormRules">
        <el-form-item label="管理员名称:" prop="account_id">
          <el-select v-model="addForm.account_id" placeholder="请选择">
            <el-option v-for="item in adminList" :key="item.account_id" :label="item.nickname" :value="item.account_id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">关 闭</el-button>
        <el-button size="small" type="primary" @click="submitSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sealAdd, adminList, sealList, sealDel, getSeal, orgAccountCreate } from '@/api/invoice'
export default {
  data() {
    return {
      curUser: -1,
      companySeal: '',
      userArr: [],
      addForm: {
        account_id: ''
      },
      adminList: [],
      uploadFormRules: {
        account_id: [
          { required: true, message: '请选择管理员', trigger: 'change' }
        ]
      },
      addVisible: false
    }
  },
  async mounted() {
    this.getSeal()
    this.sealListFn()
  },
  methods: {
    async getSeal() {
      const data = await getSeal()
      if (data.code === 200) {
        this.companySeal = data.data.seal_img || ''
      }
    },
    async sealListFn() {
      const data = await sealList()
      if (data.code === 200) {
        this.userArr = data.data
      }
    },
    clickUser(item) {
      this.curUser = item.account_id
    },
    close(item) {
      this.$confirm('删除后该员工将失去印章使用权!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        sealDel({
          account_id: item.account_id
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功!')
            this.sealListFn()
          }
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    async addUser() {
      const data = await adminList()
      if (data.code === 200) {
        this.adminList = data.data
        this.addVisible = true
      }
    },
    submitSave() {
      this.$refs.addForm.validate(async(valid) => {
        if (valid) {
          sealAdd({
            account_id: this.addForm.account_id
          }).then(data => {
            if (data.code === 200) {
              this.$message.success('添加成功!')
              this.$refs.addForm.resetFields()
              this.addVisible = false
              this.sealListFn()
            }
          })
        }
      })
    },
    beforeClose(done) {
      this.$refs.addForm.resetFields()
      done()
    },
    cancel() {
      this.$refs.addForm.resetFields()
      this.addVisible = false
    },
    async apply() {
      const data = await orgAccountCreate()
      if (data.code === 200) {
        this.$message.success('申请成功!')
        this.getSeal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.seal{
  .tit{
    margin-top: 40px;
    .txt{
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      margin: 0 20px 0 10px;
    }
    display: flex;
    align-items: center;
    &::before{
      content: '';
      width: 2px;
      height: 18px;
      background: #4196F0;
    }
  }
  .seal-img{
    margin-top: 20px;
    margin-left: 20px;
    .img{
      width: 160px;
      margin-right: 20px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
  .tips{
    font-size: 12px;
    color: #FF8100;
  }
  .auth-seal{
    flex-direction: row;
    flex-wrap: wrap;
    .auth-item{
      width: 220px;
      height: 80px;
      border-radius: 4px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: relative;
      margin: 0 20px 20px 0;
      &:last-child{
        margin-right: 0;
      }
    }
    .list{
      border: 1px solid #C9C9C9;
      i{
        position: absolute;
        font-size: 18px;
        top: -9px;
        right: -9px;
        background-color: #fff;
        color: #F56C6C;
      }
      &.active{
        border: 1px solid #4196F0;
        color: #4196F0;
      }
    }
    .add-seal{
      border: 1px dashed #4196F0;
      i{
        font-size: 30px;
        color: #4196F0;
      }
    }
  }
}
</style>
